class HowSupergutWorks extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.sectionId = this.getAttribute('data-section-id');

    // Store bound methods so add/removeEventListener match
    this.onSectionLoad = this.onSectionLoad.bind(this);
    this.onSectionUnload = this.onSectionUnload.bind(this);
  }

  connectedCallback() {
    this.init();
    document.addEventListener('shopify:section:load', this.onSectionLoad);
    document.addEventListener('shopify:section:unload', this.onSectionUnload);
  }

  disconnectedCallback() {
    this.destroy();
    document.removeEventListener('shopify:section:load', this.onSectionLoad);
    document.removeEventListener('shopify:section:unload', this.onSectionUnload);
  }

  init() {
    if (window.Swiper && this.sectionId) {
      const selector = `#how-supergut-works-${this.sectionId}`;
      const swiperEl = document.querySelector(selector);

      // Prevent duplicate swiper initialization
      if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

      this.swiper = new Swiper(selector, {
        slidesPerView: 1.4,
        spaceBetween: 20,
        centeredSlides: false,
        autoHeight: false,
        navigation: {
          nextEl: `${selector} .how-supergut-works__swiper-next`,
          prevEl: `${selector} .how-supergut-works__swiper-prev`,
        },
        pagination: {
          el: `${selector} .how-supergut-works__pagination`,
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
        },
        breakpoints: {
          640: { slidesPerView: 2, spaceBetween: 20, centeredSlides: false },
          990: { slidesPerView: 3, spaceBetween: 20, centeredSlides: false },
          1200: { slidesPerView: 4, spaceBetween: 20, centeredSlides: false },
          1500: { slidesPerView: 4, spaceBetween: 0, centeredSlides: false },
        },
        loop: false,
        watchOverflow: true,
        grabCursor: true,
        speed: 300,
      });
    }
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  onSectionLoad(e) {
    if (e.detail && e.detail.sectionId === this.sectionId) {
      this.destroy();
      this.init();
    }
  }

  onSectionUnload(e) {
    if (e.detail && e.detail.sectionId === this.sectionId) {
      this.destroy();
    }
  }
}

if (!customElements.get('how-supergut-works')) {
  customElements.define('how-supergut-works', HowSupergutWorks);
}
